import { forkJoin } from 'rxjs';

/**
 * @since 1.0.0
 * @author ApMod Development Team
 */

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ClientContextService } from './client-context.service';
import { LoggerService } from './logger.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefDataService {

  private _isProd: boolean = environment.production;
  dynamicConfigs: any = null;

  constructor(private _apiService: ApiService,
              private _clientContextService: ClientContextService,
              private _logger: LoggerService) {

  }

  getRefData(): void {
    const baseUrl = 'https://zs9vpcvf7f.execute-api.us-east-1.amazonaws.com/dev';
    const extraHeaders = {
      'x-api-key': 'iqgTsAH4ps1MkDm9DCzTg6nlN47TTloq64cz42YB'
    };

    const exams$ = this._apiService.getJson('/assets/configs/exams.json');
    const admins$ = this._apiService.getJson('/assets/configs/admins.json');
    const events$ = this._apiService.get(`${baseUrl}/events`, true, {}, extraHeaders);
    const apmcErrors$ = this._apiService.getJson('/assets/configs/apmc-errors.json');
    const forms$ = this._apiService.getJson('/assets/configs/forms.json');
    const countries$ = this._apiService.getJson('/assets/configs/countries.json');
    const states$ = this._apiService.getJson('/assets/configs/states.json');
    const awards$ = this._apiService.get(`${baseUrl}/reference-data/awardtypes`, true, {}, extraHeaders);
    const awardsSourceMapping$ = this._apiService.get(`${baseUrl}/reference-data/award_source_mappings`, true, {}, extraHeaders);
    const awardNoOfPrevAdmins$ = this._apiService.get(`${baseUrl}/reference-data/num_previous_adm_yr`, true, {}, extraHeaders);
    const currentAdminYear$ = this._apiService.get(`${baseUrl}/reference-data/CURRNT_ADM_YR`, true, {}, extraHeaders);

    forkJoin([exams$, admins$, events$, apmcErrors$, forms$, countries$, states$, awards$, awardsSourceMapping$,
      awardNoOfPrevAdmins$, currentAdminYear$]).subscribe((results) => {
        const exams = results[0];
        const admins = results[1];
        const events = results[2];
        const apmcErrors = results[3];
        const forms = results[4];
        const countries = results[5];
        const states = results[6];
        const awards = results[7]?.value;
        const awardsSourceMapping = results[8]?.value;
        const awardNoOfPrevAdmins = results[9]?.value;
        const currentAdminYear = results[10]?.value;

        const refData = {
          'exams': exams,
          'admins': admins,
          'events': events,
          'apmcErrors': apmcErrors,
          'forms': forms,
          'countries': countries,
          'states': states,
          'awards': awards,
          'awardSourceMappings': awardsSourceMapping,
          'awardNoOfPrevAdmins': awardNoOfPrevAdmins,
          'currentAdminYear': currentAdminYear,
        };
        this._clientContextService.setRefData(refData);
      });

  }

}

